// Use gw-pl-accordion-chevron to provide a chevron containing HTML
//   <gw-pl-accordion-chevron is-open="isOpen"></gw-pl-accordion-chevron>

define([
        'text!edge/platform/widgets/accordion/directives/templates/accordion-chevron.html'
    ],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'EA',
                replace: true,
                template: templateStr,
                scope: {
                    isOpen: '='
                }
            };
        }];
    });


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/accordion/directives/accordionChevron.js